import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import CorpListCardInfoPopup from './corp-list-card-info-popup';
import CorpListStore from './corp-list-store';
import CorpInfoStore from '../corp-info/corp-info-store';

const CorpListCardInfoPopupContainer = ({ customerCode, corpType }) => {
  // console.log('CorpListCardInfoPopupContainer Load');

  const { visibleCardInfoPopup } = CorpListStore;
  const [cardInfo, setCardInfo] = useState();

  useEffect(() => {
    // console.log('CorpListCardInfoPopupContainer > useEffect()');

    if (visibleCardInfoPopup) {
      setCardInfo({
        cardNo1: '',
        cardNo2: '',
        cardNo3: '',
        cardNo4: '',
        expireDate1: '',
        expireDate2: '',
        password: '',
        authValue: '',
      });
    }
  }, [customerCode, visibleCardInfoPopup]);

  const onValueChanged = useCallback((name, e) => {
    // console.log(e);
    const { value } = e;

    // console.log(`onValueChanged - name : ${name}, value : ${value}`);

    setCardInfo((cardInfo) => ({
      ...cardInfo,
      [name]: value,
    }));
  }, []);

  const onClickSave = useCallback(async () => {
    if (!cardInfo.cardNo1 || cardInfo.cardNo1.length !== 4) {
      alert('첫 번째 카드번호 4자를 입력해 주시기 바랍니다.');
      return;
    }

    if (!cardInfo.cardNo2 || cardInfo.cardNo2.length !== 4) {
      alert('두 번째 카드번호 4자를 입력해 주시기 바랍니다.');
      return;
    }

    if (!cardInfo.cardNo3 || cardInfo.cardNo3.length !== 4) {
      alert('세 번째 카드번호 4자를 입력해 주시기 바랍니다.');
      return;
    }

    if (!cardInfo.cardNo4 || cardInfo.cardNo4.length !== 4) {
      alert('네 번째 카드번호 4자를 입력해 주시기 바랍니다.');
      return;
    }

    if (
      !cardInfo.expireDate1 ||
      !(
        parseInt(cardInfo.expireDate1) >= 0 &&
        parseInt(cardInfo.expireDate1) <= 12
      )
    ) {
      alert('유효기간(월) 1 ~ 12 까지의 숫자를 입력해 주시기 바랍니다.');
      return;
    }

    if (!cardInfo.expireDate2 || cardInfo.expireDate2.length !== 2) {
      alert('유효기간(년) 2자를 입력해 주시기 바랍니다.');
      return;
    }

    if (!cardInfo.password || cardInfo.password.length !== 2) {
      alert('비밀번호 앞 2자를 입력해 주시기 바랍니다.');
      return;
    }

    if (
      !cardInfo.authValue ||
      !(cardInfo.authValue.length === 6 || cardInfo.authValue.length === 10)
    ) {
      alert('생년월일(6자) 또는 사업자번호(10자)를 입력해 주시기 바랍니다.');
      return;
    }

    const result = await CorpListStore.insertCardInfo(
      customerCode,
      corpType,
      cardInfo
    );

    if (result.error) {
      alert(result.message);
    } else {
      CorpListStore.setVisibleCardInfoPopup(false);

      if (corpType === 0) {
        CorpInfoStore.getCusEntInfo();
      } else {
        CorpListStore.setVisibleDetailInfoPopup(false);
        CorpListStore.getUserList();
      }
    }
  }, [customerCode, corpType, cardInfo]);

  if (!cardInfo) {
    return;
  }

  return (
    <CorpListCardInfoPopup
      onHiding={() => CorpListStore.setVisibleCardInfoPopup(false)}
      onValueChanged={onValueChanged}
      onClickSave={onClickSave}
      cardInfo={cardInfo}
      visibleCardInfoPopup={visibleCardInfoPopup}
    />
  );
};

export default React.memo(observer(CorpListCardInfoPopupContainer));
